import { render, staticRenderFns } from "./tooltip.vue?vue&type=template&id=f13f4992&"
import script from "./tooltip.vue?vue&type=script&lang=js&"
export * from "./tooltip.vue?vue&type=script&lang=js&"
import style0 from "./tooltip.vue?vue&type=style&index=0&id=f13f4992&prod&class=c-tooltip&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports